/**
 * UI.4 — Bottom bar fixa mobile (md:hidden). Nav estilo app: 4 tabs.
 * Esconde em telas de auth, redirect, admin (via pathname prefix).
 */
'use client'

import { cn } from '@/lib/utils'
import { Bookmark, Home, Search, User } from 'lucide-react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const TABS = [
  { href: '/', label: 'Início', icon: Home },
  { href: '/buscar', label: 'Buscar', icon: Search },
  { href: '/dashboard', label: 'Favoritas', icon: Bookmark },
  { href: '/profile', label: 'Perfil', icon: User },
] as const

// Exportado para o CookieConsentBanner (colisão com a nav em mobile —
// achado do PLAN-ui-acessibilidade-mobile.md item 2) reusar a mesma regra
// de onde a bottom bar aparece, em vez de duplicar a lista.
export const HIDDEN_PREFIXES = ['/redirect', '/auth', '/admin', '/api']

export function MobileBottomBar() {
  const pathname = usePathname()
  if (!pathname) return null
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null

  // Telas com SearchLayout (/buscar, /dashboard, /pricing, /jobs/[id],
  // /[categoria]/[cidade]) já têm nav mobile própria, com as abas da área
  // logada e visível até lg. Esconder por :has cobre todas elas, inclusive a
  // rota dinâmica da raiz, que uma lista de prefixos não alcançaria.
  return (
    <nav
      aria-label="Navegação principal"
      className="fixed bottom-0 inset-x-0 z-40 md:hidden [body:has([data-app-shell])_&]:hidden bg-white/95 dark:bg-zinc-950/95 backdrop-blur border-t border-zinc-200 dark:border-zinc-800 pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid grid-cols-4">
        {TABS.map((tab) => {
          const active = tab.href === '/' ? pathname === '/' : pathname.startsWith(tab.href)
          const Icon = tab.icon
          return (
            <li key={tab.href}>
              <Link
                href={tab.href}
                className={cn(
                  'flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] text-[10px] font-medium',
                  active
                    ? 'text-blue-600 dark:text-blue-400'
                    : 'text-zinc-500 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100',
                )}
                aria-current={active ? 'page' : undefined}
              >
                <Icon className="h-5 w-5" strokeWidth={active ? 2.5 : 2} />
                <span>{tab.label}</span>
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
